import type { Alpha2LanguageCode } from '~/types/partner'

export const useTrackedClicks = () => useState<string[]>('tracked-clicks', () => [])
export const useLanguages = () => useState<{ label: string, value: number, alpha2: Alpha2LanguageCode }[]>('languages', () => [])

export const useCopilotEditorOpen = () => useState<boolean>('copilot-editor-open', () => false)
